// import logo from './logo.svg';
import './App.css';
import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Pagination, Navigation } from "swiper";
import SwiperCore from 'swiper';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css';
import swiperImg01 from './assets/index/wap-swiper-01.png';
import swiperImg02 from './assets/index/wap-swiper-02.png';
import swiperImg03 from './assets/index/wap-swiper-03.png';
/* <img src={logo} className="App-logo" alt="logo" /> */
/* <header className="App-header">

<p>
  Edit <code>src/App.js</code> and save to reload.
</p>
<a
  className="App-link"
  href="https://reactjs.org"
  target="_blank"
  rel="noopener noreferrer"
>
  Learn React
</a>
</header> */
function App() {
  SwiperCore.use([Autoplay, Pagination])
  return (
    <div className="App">
      <div className='nav'>
        <div className='nav-wrap'>
          <div className='nav-logo'></div>
          <div className='nav-name'>驿站</div>
          <div className='nav-slogan'>躺赚收益</div>
        </div>
      </div>
      <div className='body-item body-item-01'>
        <div className='body-item-wrap'>
          <div className='item-title'>分布式共享边缘计算服务</div>
          <div className='item-desc'>租用您设备的闲置空间开设缓存资源驿站，<br />通过收发缓存资源赚取积分收益的一款实用工具</div>
          <div className='item-icon'></div>
        </div>
      </div>
      <div className='body-item body-item-02'>
        <div className='body-item-wrap'>
          <div className='item-title'>共享闲置资源 创造更多价值回报</div>
          <div className='item-desc'>整合闲置设备 为用户提供灵活高效的计算服务</div>
        </div>
      </div>
      <div className='body-item body-item-03'>
        <div className='body-item-wrap'>
          <div className='item-title'>轻松兑换VIP会员及电话费</div>
          <div className='item-desc'>稳定&nbsp;&nbsp;｜&nbsp;&nbsp;省心&nbsp;&nbsp;|&nbsp;&nbsp;躺赚</div>
        </div>
      </div>
      <div className='body-item body-item-04'>
        <div className='body-item-wrap'>
          <div className='item-title'>缓存加速 上网快人一步</div>
          <div className='item-desc'>预缓存热门资源进行上网加速</div>
        </div>
      </div>
      <div className='body-item body-item-05' style={{ "display": "none" }}>
        <div className='body-item-wrap'>
          <div className='item-title'>设备管理便捷 数据展示清晰</div>
          <div className='item-sub-title'>
            <div className='sub-title-icon'></div>
            <div className='sub-title-text'>多端清晰展示</div>
          </div>
          <div className='item-desc'>清晰展示积分收益获取趋势图<br />
            轻松切换绑定设备，管理更方便</div>
        </div>
      </div>
      <div className='body-item body-item-06'>
        <div className='body-item-wrap'>
          <div className='item-title'>三步让你的设备更有用</div>
          <div className='item-step'>
            <div className='step-item'>
              <div className='step-num'>1</div>
              <div className='step-name'>下载安装</div>
              <div className='step-desc'>下载安装“驿站”到您的电脑</div>
            </div>
            <div className='step-item'>
              <div className='step-num'>2</div>
              <div className='step-name'>绑定账号</div>
              <div className='step-desc'>绑定“驿站“账号，随时监管设备</div>
            </div>
            <div className='step-item'>
              <div className='step-num'>3</div>
              <div className='step-name'>积分到账</div>
              <div className='step-desc'>使用“驿站”，兑换想要的礼品，流量变现快</div>
            </div>
          </div>
          {/* <div className='download-btn'>下载驿站</div> */}
        </div>

      </div>
      <div className='body-item body-item-contact'>
        <div className='body-item-wrap'>
          <div className='contact-item-wrap'>
            <div className='contact-item contact-item-wechat'>
              <div className='contact-item-icon'></div>
              <div className='contact-item-text'>微信：ionewu001</div>
            </div>
            <div className='contact-item contact-item-phone'>
              <div className='contact-item-icon'></div>
              <div className='contact-item-text'>联系方式：0755-86607260</div>
            </div>
            <div className='contact-item contact-item-email'>
              <div className='contact-item-icon'></div>
              <div className='contact-item-text'>邮箱：kf@ionewu.com</div>
            </div>
            <div className='contact-item contact-item-location'>
              <div className='contact-item-icon'></div>
              <div className='contact-item-text'>地址：深圳市南山区西丽创智云城A7-2302</div>
            </div>
          </div>
          <div className='contact-qrcode'>
            <div className='contact-qrcode-img'></div>
            <div className='contact-qrcode-text'>联系客服</div>
          </div>
          <div className='contact-bottom'>@2020 版权所有 深圳市玩物科技有限公司 粤ICP备18147482号-1粤公网安备 44030502004455号</div>
        </div>
      </div>

      <div className='body-wap-item wap-item-01'>
        <div className='wap-item-title'>
          分布式<br />
          共享边缘计算服务
        </div>
        <div className='wap-item-hr'></div>
        <div className='wap-item-desc'>租用您设备的闲置空间开设缓存资源驿站<br />
          通过收发缓存资源赚取积分收益的一款实用工具</div>
        <div className='wap-item-body'></div>
      </div>
      <div className='body-wap-item wap-item-02'>
        <div className='wap-item-title'>
          共享闲置资源<br />
          创造更多价值回报
        </div>
        <div className='wap-item-hr'></div>
        <div className='wap-item-desc'>整合闲置设备 为用户提供灵活高效的计算服务</div>
        <div className='wap-item-body'></div>
      </div>
      <div className='body-wap-item wap-item-03'>
        <div className='wap-item-title'>
          轻松兑换<br />
          VIP会员及电话费
        </div>
        <div className='wap-item-hr'></div>
        <div className='wap-item-desc'>稳定 | 省心 | 躺赚</div>
        <Swiper
          className='wap-swiper'
          spaceBetween={100}
          slidesPerView={1}
          onSlideChange={() => console.log('slide change')}
          onSwiper={(swiper) => console.log(swiper)}
          loop={true}
          autoplay={{
            delay: 3000, // ms
          }}
          pagination={{ clickable: true }}
        // modules={[Autoplay, Pagination, Navigation]}
        >
          <SwiperSlide className='wap-swiper-slide'>
            <img src={swiperImg01} />
          </SwiperSlide>
          <SwiperSlide className='wap-swiper-slide'><img src={swiperImg02} /></SwiperSlide>
          <SwiperSlide className='wap-swiper-slide'><img src={swiperImg03} /></SwiperSlide>
        </Swiper>
      </div>
      <div className='body-wap-item wap-item-04'>
        <div className='wap-item-title'>
          缓存加速<br />
          上网快人一步
        </div>
        <div className='wap-item-hr'></div>
        <div className='wap-item-desc'>预缓存热门资源进行上网加速</div>
        <div className='wap-item-body'></div>
      </div>
      <div className='body-wap-item wap-item-05'>
        <div className='wap-item-title'>
          三步让你的设备<br />更有用
        </div>
        <div className='wap-item-body'></div>
      </div>
      <div className='body-wap-item wap-item-06'></div>
    </div >
  );
}

export default App;
